// UserContext.js
import React, { createContext, useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import api from "./api";
import { WebSocketProvider } from './components/socket';
import { Navigate } from 'react-router-dom';
const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("api/UserData/").then((response) => {
            if (response.data.number == null) {
                response.data.number = "";
            }
            let u = response.data;
            u["last"] = []
            u["active"] = null;
                setUser(u);
            setLoading(false);
        }
        ).catch((error) => {
            setLoading(false);
            if (error.response.status === 401) {
                window.location.reload();
            }
        });
    }, []);

    if (loading) {
        return <div id='loading-spinner'><div className="spinner-border text-primary" role="status">
        </div></div>;
    }
    return (
        <UserContext.Provider value={{ user, setUser }}>
            <WebSocketProvider>
                <Navbar />
                {user.subscription.status !== "active" && (window.location.pathname === "/profile" || window.location.pathname === "/chats") ? <Navigate to="/settings" /> : children}
            </WebSocketProvider>
        </UserContext.Provider>
    );
};
export { UserContext, UserProvider };
